// extracted by mini-css-extract-plugin
export var activeFilterButton = "_q6-c";
export var backButton = "_q6-4";
export var backIcon = "_q6-5";
export var chevronShortcut = "_q6-6";
export var container = "_q6-1";
export var editor = "_q6-8";
export var editorWrapper = "_q6-7";
export var prefix = "_q6-2";
export var searchIcon = "_q6-3";
export var suffix = "_q6-9";
export var suffixContent = "_q6-a";
export var suffixText = "_q6-b";
export var wrapper = "_q6-0";